// extracted by mini-css-extract-plugin
module.exports = {"planning":"Title_planning__3cyty","tasks":"Title_tasks__y8BFP","edit":"Title_edit__2StON"};